import axios from 'axios'

export default {
    createChat(senderId, receiverId) {
        return axios.post('/api/chat/create-room', {
            sender_id: senderId,
            receiver_id: receiverId
        })
    },

    loadChat(chatId) {
        return axios.get('/api/chat/' + chatId)
    },

    loadMyChats() {
        return axios.get('/api/chat/my-chats')
    },

    loadFriends() {
        return axios.get('/api/my-friends')
    },

    search(query) {
        return axios.post('/api/search-user', {
            query: query
        })
    }
}
